import { render, staticRenderFns } from "./shopQualificationList.vue?vue&type=template&id=5d6e9fe9&scoped=true&"
import script from "./shopQualificationList.vue?vue&type=script&lang=js&"
export * from "./shopQualificationList.vue?vue&type=script&lang=js&"
import style0 from "./shopQualificationList.vue?vue&type=style&index=0&id=5d6e9fe9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6e9fe9",
  null
  
)

export default component.exports